var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "19", height: "18", viewBox: "0 0 19 18", fill: "none" }, props),
    React.createElement("path", { d: "M16.25 14.625H2.75V3.375", stroke: "#018489", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.125 4.5L9.5 10.125L7.25 7.875L2.75 12.375", stroke: "#018489", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.125 7.3125V4.5H12.3125", stroke: "#018489", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});